import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { isEscapePressed } from "../../../../utils/eventKeys";
import { togglePageFix as _togglePageFix } from "../../../../utils/scrollFixer";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * FixedOverlay is a stateless component with no layout
 * it provides open/close mechanics with scroll fixing
 * automatically closes on pressing Escape if onClose is passed
 *
 * Used as root component for custom Popup implementations
 */
var FixedOverlay = /*#__PURE__*/function (_React$Component) {
  _inherits(FixedOverlay, _React$Component);
  var _super = _createSuper(FixedOverlay);
  function FixedOverlay() {
    var _this;
    _classCallCheck(this, FixedOverlay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * isFixed is not state, because it controls sideEffect
     * it syncs with this.props.isOpen
     */
    _defineProperty(_assertThisInitialized(_this), "isFixed", false);
    /**
     * to fix an issue with popup closing, when user clicks
     * on an element inside popup and moves mouse outside
     * we keep track of what element was clicked before
     */
    _defineProperty(_assertThisInitialized(_this), "closeTargetMismatch", false);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      return _this.togglePageFix(_this.props.isOpen);
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      return _this.togglePageFix(_this.props.isOpen);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      return _this.togglePageFix(false);
    });
    _defineProperty(_assertThisInitialized(_this), "handleEscapeKey", function (event) {
      if (isEscapePressed(event)) _this.props.onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "handleContainerClick", function (event) {
      if (event.target === event.currentTarget && !_this.closeTargetMismatch) _this.props.onClose();
      _this.closeTargetMismatch = false;
    });
    _defineProperty(_assertThisInitialized(_this), "handleContainerMouseDown", function (event) {
      _this.closeTargetMismatch = event.target !== event.currentTarget;
    });
    return _this;
  }
  _createClass(FixedOverlay, [{
    key: "togglePageFix",
    value:
    /**
     * Wrapper around togglePageFix, only fires if value changes
     */
    function togglePageFix(isOpen) {
      if (isOpen !== this.isFixed) {
        this.isFixed = isOpen;
        if (isOpen && this.props.onClose) {
          document.addEventListener('keydown', this.handleEscapeKey);
        } else {
          document.removeEventListener('keydown', this.handleEscapeKey);
        }
        _togglePageFix(isOpen);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        hasScrollOverlay = _this$props.hasScrollOverlay;
      return isOpen ? /*#__PURE__*/React.createElement("div", {
        className: cx('component', {
          scrollOverlay: hasScrollOverlay
        }, className),
        onClick: this.handleContainerClick,
        onMouseDown: this.handleContainerMouseDown,
        role: "presentation",
        "data-t-id": "components-FixedOverlay"
      }, children) : null;
    }
  }]);
  return FixedOverlay;
}(React.Component);
export { FixedOverlay as default };
FixedOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  hasScrollOverlay: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string
} : {};
FixedOverlay.defaultProps = {
  isOpen: false
};